import { Injectable } from '@angular/core';
// import {NgxTourPrimeNgModule} from './ngx-tour-prime-ng.module';

@Injectable({
  providedIn: 'root'
})
export class TourStepTemplateService {
  public component: any;
}
